export const FETCH_STR_CASE_REPORT_BY_CASE_ID =
  'FETCH_STR_CASE_REPORT_BY_CASE_ID';
export const FETCH_STR_CASE_REPORT_BY_CASE_ID_SUCCESS =
  'FETCH_STR_CASE_REPORT_BY_CASE_ID_SUCCESS';
export const FETCH_STR_CASE_REPORT_BY_CASE_ID_FAIL =
  'FETCH_STR_CASE_REPORT_BY_CASE_ID_FAIL';

export const UPDATE_STR_CASE_REPORT_BY_CASE_ID =
  'UPDATE_STR_CASE_REPORT_BY_CASE_ID';
export const UPDATE_STR_CASE_REPORT_BY_CASE_ID_SUCCESS =
  'UPDATE_STR_CASE_REPORT_BY_CASE_ID_SUCCESS';
export const UPDATE_STR_CASE_REPORT_BY_CASE_ID_FAIL =
  'UPDATE_STR_CASE_REPORT_BY_CASE_ID_FAIL';

export const CREATE_STR_CASE_REPORT_BY_CASE_ID =
  'CREATE_STR_CASE_REPORT_BY_CASE_ID';
export const CREATE_STR_CASE_REPORT_BY_CASE_ID_SUCCESS =
  'CREATE_STR_CASE_REPORT_BY_CASE_ID_SUCCESS';
export const CREATE_STR_CASE_REPORT_BY_CASE_ID_FAIL =
  'CREATE_STR_CASE_REPORT_BY_CASE_ID_FAIL';
export const CLOSE_SUCCESS_MODAL = 'CLOSE_SUCCESS_MODAL';
export const CLOSE_ERROR_MODAL = 'CLOSE_ERROR_MODAL';

export const FETCH_REPORT_METADATA = 'FETCH_REPORT_METADATA';
export const FETCH_REPORT_METADATA_SUCCESS = 'FETCH_REPORT_METADATA_SUCCESS';
export const FETCH_REPORT_METADATA_FAIL = 'FETCH_REPORT_METADATA_FAIL';

export const FETCH_TRANSACTION_LIST = 'FETCH_TRANSACTION_LIST';
export const FETCH_TRANSACTION_LIST_SUCCESS = 'FETCH_TRANSACTION_LIST_SUCCESS';
export const FETCH_TRANSACTION_LIST_FAIL = 'FETCH_TRANSACTION_LIST_FAIL';

export const FETCH_PARTIES_LIST = 'FETCH_PARTIES_LIST';
export const FETCH_PARTIES_LIST_SUCCESS = 'FETCH_PARTIES_LIST_SUCCESS';
export const FETCH_PARTIES_LIST_FAIL = 'FETCH_PARTIES_LIST_FAIL';

export const FETCH_TRANSACTION_LIST_DOWNLOAD =
  'FETCH_TRANSACTION_LIST_DOWNLOAD';
export const FETCH_TRANSACTION_LIST_DOWNLOAD_SUCCESS =
  'FETCH_TRANSACTION_LIST_DOWNLOAD_SUCCESS';
export const FETCH_TRANSACTION_LIST_DOWNLOAD_FAIL =
  'FETCH_TRANSACTION_LIST_DOWNLOAD_FAIL';

export const UPDATE_REPORTING_INSTITUTION = 'UPDATE_REPORTING_INSTITUTION';
export const UPDATE_REPORTING_INSTITUTION_SUCCESS =
  'UPDATE_REPORTING_INSTITUTION_SUCCESS';
export const UPDATE_REPORTING_INSTITUTION_FAIL =
  'UPDATE_REPORTING_INSTITUTION_FAIL';
export const CLEAR_REPORTING_INSTITUTION_ERROR =
  'CLEAR_REPORTING_INSTITUTION_ERROR';

export const UPDATE_TRANSACTION_LIST = 'UPDATE_TRANSACTION_LIST';
export const UPDATE_TRANSACTION_LIST_SUCCESS =
  'UPDATE_TRANSACTION_LIST_SUCCESS';
export const UPDATE_TRANSACTION_LIST_FAIL = 'UPDATE_TRANSACTION_LIST_FAIL';
export const CLEAR_TRANSACTION_LIST_ERROR = 'CLEAR_TRANSACTION_LIST_ERROR';

export const UPDATE_PARTIES_LIST = 'UPDATE_PARTIES_LIST';
export const UPDATE_PARTIES_LIST_SUCCESS = 'UPDATE_PARTIES_LIST_SUCCESS';
export const UPDATE_PARTIES_LIST_FAIL = 'UPDATE_PARTIES_LIST_FAIL';
export const CLEAR_PARTIES_LIST_ERROR = 'CLEAR_PARTIES_LIST_ERROR';

export const UPDATE_INVESTIGATION_DETAILS = 'UPDATE_INVESTIGATION_DETAILS';
export const UPDATE_INVESTIGATION_DETAILS_SUCCESS =
  'UPDATE_INVESTIGATION_DETAILS_SUCCESS';
export const UPDATE_INVESTIGATION_DETAILS_FAIL =
  'UPDATE_INVESTIGATION_DETAILS_FAIL';
export const CLEAR_INVESTIGATION_DETAILS_ERROR =
  'CLEAR_INVESTIGATION_DETAILS_ERROR';

export const fetchSTRCaseReportByCaseId = (payload) => ({
  type: FETCH_STR_CASE_REPORT_BY_CASE_ID,
  payload: payload
});

export const fetchSTRCaseReportByCaseIdSuccess = (reportDetails) => ({
  type: FETCH_STR_CASE_REPORT_BY_CASE_ID_SUCCESS,
  payload: reportDetails
});

export const fetchSTRCaseReportByCaseIdFail = (message) => ({
  type: FETCH_STR_CASE_REPORT_BY_CASE_ID_FAIL,
  payload: { message }
});

export const updateSTRCaseReportByCaseId = (reportUpatedFields) => ({
  type: UPDATE_STR_CASE_REPORT_BY_CASE_ID,
  payload: { reportUpatedFields }
});

export const updateSTRCaseReportByCaseIdSuccess = () => ({
  type: UPDATE_STR_CASE_REPORT_BY_CASE_ID_SUCCESS
});

export const updateSTRCaseReportByCaseIdFail = (message) => ({
  type: UPDATE_STR_CASE_REPORT_BY_CASE_ID_FAIL,
  payload: { message }
});

export const createSTRCaseReportByCaseId = ({ caseId, alertIds }) => ({
  type: CREATE_STR_CASE_REPORT_BY_CASE_ID,
  payload: { caseId, alertIds }
});

export const createSTRCaseReportByCaseIdSuccess = (reportDetails) => ({
  type: CREATE_STR_CASE_REPORT_BY_CASE_ID_SUCCESS,
  payload: reportDetails
});

export const createSTRCaseReportByCaseIdFail = (message) => ({
  type: CREATE_STR_CASE_REPORT_BY_CASE_ID_FAIL,
  payload: { message }
});

export const closeSuccessModal = () => ({
  type: CLOSE_SUCCESS_MODAL
});

export const closeErrorModal = () => ({
  type: CLOSE_ERROR_MODAL
});

export const fetchReportMetadata = (payload) => ({
  type: FETCH_REPORT_METADATA,
  payload
});

export const fetchReportMetadataSuccess = (data) => ({
  type: FETCH_REPORT_METADATA_SUCCESS,
  payload: data
});

export const fetchReportMetadataFail = (message) => ({
  type: FETCH_REPORT_METADATA_FAIL,
  payload: { message }
});

export const fetchTransactionList = (payload) => ({
  type: FETCH_TRANSACTION_LIST,
  payload
});

export const fetchTransactionListSuccess = (data) => ({
  type: FETCH_TRANSACTION_LIST_SUCCESS,
  payload: data
});

export const fetchTransactionListFail = (message) => ({
  type: FETCH_TRANSACTION_LIST_FAIL,
  payload: { message }
});

export const fetchPartiesList = (payload) => ({
  type: FETCH_PARTIES_LIST,
  payload
});

export const fetchPartiesListSuccess = (data) => ({
  type: FETCH_PARTIES_LIST_SUCCESS,
  payload: data
});

export const fetchPartiesListFail = (message) => ({
  type: FETCH_PARTIES_LIST_FAIL,
  payload: { message }
});

export const fetchTransactionListDownload = (payload) => ({
  type: FETCH_TRANSACTION_LIST_DOWNLOAD,
  payload
});

export const fetchTransactionListDownloadSuccess = (data) => ({
  type: FETCH_TRANSACTION_LIST_DOWNLOAD_SUCCESS,
  payload: data
});

export const fetchTransactionListDownloadFail = (message) => ({
  type: FETCH_TRANSACTION_LIST_DOWNLOAD_FAIL,
  payload: { message }
});

export const updateReportingInstitution = (payload) => ({
  type: UPDATE_REPORTING_INSTITUTION,
  payload
});

export const updateReportingInstitutionSuccess = (data) => ({
  type: UPDATE_REPORTING_INSTITUTION_SUCCESS,
  payload: data
});

export const updateReportingInstitutionFail = (message) => ({
  type: UPDATE_REPORTING_INSTITUTION_FAIL,
  payload: { message }
});

export const clearReportingInstitutionError = () => ({
  type: CLEAR_REPORTING_INSTITUTION_ERROR
});

export const updateTransactionList = (payload) => ({
  type: UPDATE_TRANSACTION_LIST,
  payload
});

export const updateTransactionListSuccess = () => ({
  type: UPDATE_TRANSACTION_LIST_SUCCESS
});

export const updateTransactionListFail = (message) => ({
  type: UPDATE_TRANSACTION_LIST_FAIL,
  payload: { message }
});

export const clearTransactionListError = () => ({
  type: CLEAR_TRANSACTION_LIST_ERROR
});

export const updatePartiesList = (payload) => ({
  type: UPDATE_PARTIES_LIST,
  payload
});

export const updatePartiesListSuccess = () => ({
  type: UPDATE_PARTIES_LIST_SUCCESS
});

export const updatePartiesListFail = (message) => ({
  type: UPDATE_PARTIES_LIST_FAIL,
  payload: { message }
});

export const clearPartiesListError = () => ({
  type: CLEAR_PARTIES_LIST_ERROR
});

export const updateInvestigationDetails = (payload) => ({
  type: UPDATE_INVESTIGATION_DETAILS,
  payload
});

export const updateInvestigationDetailsSuccess = (data) => ({
  type: UPDATE_INVESTIGATION_DETAILS_SUCCESS,
  payload: data
});

export const updateInvestigationDetailsFail = (message) => ({
  type: UPDATE_INVESTIGATION_DETAILS_FAIL,
  payload: { message }
});

export const clearInvestigationDetailsError = () => ({
  type: CLEAR_INVESTIGATION_DETAILS_ERROR
});
